import { useGLTF } from '@react-three/drei'
import { useFrame } from '@react-three/fiber'
import * as THREE from 'three'
import gsap from 'gsap'

const Model = () =>
{
  let mixer = null

  const { scene, animations } = useGLTF('./models/cyber.glb')

  mixer = new THREE.AnimationMixer(scene);
  mixer.clipAction(animations[0]).play()

  useFrame((state, delta)=>{
    mixer.update(delta * 0.5)
  })

  return (
    <primitive object={scene} position={[0, -0.41, 0]} scale={[0.5, 0.5, 0.5]} />
  )
}

export default Model

// useGLTF.preload('/models/toy.glb')
